/*
 * Copyright (c) 2021.
 * 2iPartners SàRL and/or its affiliates.
 * All rights reserved.
 *
 * 2iPartners SàRL
 * Route de Compois 24,
 * 1252 Meinier
 * Suisse
 *
 * tel : +41 22 735 97 07
 */

import {Component, Input, OnInit} from '@angular/core';
import {Animal} from '../../../_models/animal';
import moment from "moment";
import {Helpers} from '../../../helpers';
import {PrintService} from '../../../_services/print.service';
import {ToastrService} from 'ngx-toastr';
import {HttpErrorResponse} from '@angular/common/http';
import {saveAs} from 'file-saver';
import {DATE_TIME_FR_FORMAT, DATE_TIME_SQL_FORMAT} from '../../../_enums/constants';
import {I18nService, INVOICE, VOUCHER, VOUCHER_INVOICE} from '../../../_services/i18n.service';


@Component({
  selector: 'app-table-history-animals',
  templateUrl: './table-history-animals.component.html',
  styleUrls: ['./table-history-animals.component.scss']
})
export class TableHistoryAnimalsComponent implements OnInit {

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  ///                              COMPONENT I/O                                                                                         ///
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  @Input() data: Animal[];

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  ///                              MAGICS METHODS                                                                                        ///
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  constructor(private printService: PrintService, private i18n: I18nService, private toastr: ToastrService) {
  }

  ngOnInit() {
    // This is intentional
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  ///                              LISTENERS                                                                                             ///
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  public print(animal: Animal): void {
    if (0 < animal.amount) {
      this.printFiles(animal, `${this.i18n.get(VOUCHER_INVOICE)}_${animal.id}.pdf`);
    } else {
      this.printFiles(animal, `${this.i18n.get(VOUCHER)}_${animal.id}.pdf`);
    }
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  ///                              OTHER PUBLIC METHODS                                                                                  ///
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  public formatDate(d?: string | Date): string {
    return d ? moment(d, DATE_TIME_SQL_FORMAT).format(DATE_TIME_FR_FORMAT) : '';
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  ///                              PRIVATE METHODS                                                                                       ///
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  private printFiles(animal: Animal, filename: string) {
    Helpers.setLoading(true);

    this.printService.printAnimalFiles(animal.id, {version: 1.3}).subscribe(data => {
      Helpers.setLoading(false);
      saveAs(data, filename);
    }, (err: HttpErrorResponse) => this.handleError(err));
  }

  private printVoucher(animal: Animal) {
    Helpers.setLoading(true);

    this.printService.printAnimalVoucher([animal.id], {version: 0.6}).subscribe(data => {
      Helpers.setLoading(false);
      saveAs(data, `${this.i18n.get(VOUCHER)}_${animal.id}.pdf`);
    }, (err: HttpErrorResponse) => this.handleError(err));
  }

  private printInvoice(animal: Animal) {
    Helpers.setLoading(true);

    this.printService.printRemovalInvoice([animal.removalId], {version: 0.6}).subscribe(data => {
      Helpers.setLoading(false);
      saveAs(data, `${this.i18n.get(INVOICE)}_${animal.removalId}.pdf`);
    }, (err: HttpErrorResponse) => this.handleError(err));
  }

  private handleError(err: HttpErrorResponse): void {
    Helpers.setLoading(false);
    this.toastr.error(`${err.status} - ${this.i18n.get(err.status)}`);
  }

}
